import { api } from "./api";
export const handleLoginApi = (params: { email: string; password: string }) => {
  return api.post(`/auth/user/login`, {
    user_email: params.email,
    password: params.password,
  });
};